import { render } from "./ScrollPane.vue?vue&type=template&id=087e49d8&scoped=true&ts=true"
import script from "./ScrollPane.vue?vue&type=script&lang=ts"
export * from "./ScrollPane.vue?vue&type=script&lang=ts"

import "./ScrollPane.vue?vue&type=style&index=0&id=087e49d8&lang=scss&scoped=true"

import exportComponent from "E:\\项目对接\\parent-reporting-backend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-087e49d8"]])

export default __exports__